<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <div class="item" v-bind="attrs" :class="{ edit: editing }" v-on="on">
        <PdfFile />
        <slot></slot>
      </div>
    </template>
    <transition-group v-if="dialog" :duration="150">
      <PDFJSViewer
        key="PDFJSViewer"
        :url="typeof url === 'string' ? apiDomain + '/' + url : onShowFile(url)"
      />
      <button key="button" class="customBtn fixed" @click="closeModal">
        {{ localStorage.translations.pages.common.buttons.nazad }}
      </button>
    </transition-group>
  </v-dialog>
</template>

<script>
import PDFJSViewer from 'components/PDFJSViewer'
import PdfFile from 'components/icons/PdfFile'

export default {
  name: 'ContractPdfModal',
  components: {
    PDFJSViewer,
    PdfFile,
  },
  props: ['id', 'url', 'editing', 'disabled'],
  data() {
    return {
      dialog: false,
    }
  },
  watch: {},
  methods: {
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
    onShowFile(file) {
      return URL.createObjectURL(file)
    },
  },
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
  },
}
</script>

<style lang="scss" scoped>
.item {
  position: relative;
  display: grid;
  align-content: center;
  min-height: 120px;
  background: #465058;
  justify-content: center;
  &::before {
    content: url('data:image/svg+xml; utf8, <svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 9.10894C11.9109 9.10894 12.6493 8.38962 12.6493 7.50229C12.6493 6.61496 11.9109 5.89563 11 5.89563C10.0891 5.89563 9.35066 6.61496 9.35066 7.50229C9.35066 8.38962 10.0891 9.10894 11 9.10894Z" fill="white"/><path d="M21.8527 6.96673C21.149 5.77781 17.2785 -0.188229 10.7031 0.00456941C4.62253 0.154524 1.10393 5.36008 0.147314 6.96673C0.0508068 7.12956 0 7.31427 0 7.50229C0 7.6903 0.0508068 7.87501 0.147314 8.03784C0.840038 9.20534 4.54557 15 11.022 15H11.2969C17.3775 14.85 20.9071 9.64449 21.8527 8.03784C21.9492 7.87501 22 7.6903 22 7.50229C22 7.31427 21.9492 7.12956 21.8527 6.96673ZM11 11.2511C10.2388 11.2511 9.49478 11.0313 8.8619 10.6193C8.22903 10.2074 7.73576 9.62192 7.44448 8.93691C7.15319 8.2519 7.07698 7.49813 7.22548 6.77092C7.37397 6.04371 7.7405 5.37573 8.27872 4.85144C8.81694 4.32716 9.50267 3.97011 10.2492 3.82546C10.9957 3.68081 11.7695 3.75505 12.4727 4.03879C13.176 4.32253 13.777 4.80303 14.1999 5.41953C14.6228 6.03603 14.8485 6.76083 14.8485 7.50229C14.8485 8.49654 14.443 9.45008 13.7213 10.1531C12.9996 10.8562 12.0207 11.2511 11 11.2511Z" fill="white"/></svg>');
    transition: 0.3s;
    background: #16558fcc;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  &:hover {
    &::before {
      cursor: pointer;
      opacity: 1;
    }
  }
  &:hover {
    .hover {
      opacity: 1;
    }
  }
  &.edit {
    .hover {
      pointer-events: auto;
      display: grid;
    }
  }
}
.modalBody {
  width: 100%;
  height: 100vh;
}
.customBtn {
  padding: 15px !important;
  text-transform: capitalize;
  &.fixed {
    position: fixed;
    right: 25px;
    bottom: 10%;
  }
}
</style>
